module.exports = __webpack_public_path__ + "img/choose-up-2_2_text.3926f9dc.png";